export default {
  labels: {
    sold_out: 'Esgotado!',
    most_popular: '#{{rank}} Mais Apreciado',
    last_ordered: 'Último pedido',
  },
};
